module.exports = __webpack_public_path__ + "img/advantage18.c5f2385d.jpg";